import { useOrganisationsContext } from 'contexts';

type IdType = string | number;

export const useOrganisationId = <T extends IdType = string>() => {
  const { organisationId } = useOrganisationsContext();
  return organisationId as T;
};
